import * as React from 'react';

function SvgIconBatch(props) {
  return (
    <svg
      width={105}
      height={116}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M2 0h76a2 2 0 012 2v68L60 90H2a2 2 0 01-2-2V2C0 .9.9 0 2 0z"
          id="icon-batch_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M59.38 88.5L78.5 69.38V2a.5.5 0 00-.5-.5H2a.5.5 0 00-.5.5v86c0 .28.22.5.5.5h57.38z"
          stroke="#C8C9CB"
          strokeWidth={3}
        />
        <path
          d="M60.05 70.05H80V67H59a2 2 0 00-2 2v21h3.05V70.05zM16 42h48v-3H16zm22-11h26v-3H38zm0-11h26v-3H38zM16 53h48v-3H16zm0 11h28v-3H16z"
          fill="#C8C9CB"
          fillRule="nonzero"
        />
        <path stroke="#C8C9CB" strokeWidth={3} d="M17.5 18.5h11v11h-11z" />
        <g transform="translate(25 26)">
          <use fill="#FFF" xlinkHref="#icon-batch_svg__a" />
          <path
            stroke="#C8C9CB"
            strokeWidth={3}
            d="M59.38 88.5L78.5 69.38V2a.5.5 0 00-.5-.5H2a.5.5 0 00-.5.5v86c0 .28.22.5.5.5h57.38z"
          />
        </g>
        <path
          d="M85.05 96.05H105V93H84a2 2 0 00-2 2v21h3.05V96.05zM41 68h48v-3H41zm22-11h26v-3H63zm0-11h26v-3H63zM41 79h48v-3H41zm0 11h28v-3H41z"
          fill="#C8C9CB"
          fillRule="nonzero"
        />
        <path stroke="#C8C9CB" strokeWidth={3} d="M42.5 44.5h11v11h-11z" />
      </g>
    </svg>
  );
}

export default SvgIconBatch;
